import { gql } from '@apollo/client';

export const ONE_USER = gql`
  query getUserById($uId: ID) {
    getUserById(uId: $uId, state: [1, 2]) {
      uId
      uPasswordExpirationDate
      tiId
      typeIdentity {
        tiPrefix
      }
      uIdeNum
      ucId
      userCharge {
        ucName
      }
      uState
      profileAdminUser {
        pauId
        pauFirNam
        pauSecNam
        pauFirLas
        pauSecLas
        pauEmail
        pauPhone
        pauCompany
        pauState
      }
      adminUserMenus {
        aumId
        mId
        aumState
        adminUserSubMenus {
          ausmId
          smId
          subMenu {
            smName
          }
          ausmState
        }
      }
    }
  }
`;
// export const ONE_USERCHARGE = gql`
//   query getUserById($uId: ID) {
//     getUserById(uId: $uId, state: [0, 1, 2]) {
//       uId
//       userCharge {
//         ucId
//         ucName
//       }
//   }
// `;
